import { Box, Skeleton } from '@mui/material';

export const QuickEmailDialogSkeleton = () => {
  return (
    <Box sx={{ width: '100%' }}>
      <Skeleton variant="rounded" height={40} sx={{ marginTop: '10px', width: '100%' }} />
      <Skeleton variant="rounded" height={155} sx={{ marginTop: '20px', width: '100%' }} />
      <Box sx={{ marginTop: '35px', display: 'flex', width: '100%' }}>
        <Skeleton variant="rounded" width={85} height={35} sx={{ marginRight: '20px', marginLeft: 'auto' }} />
        <Skeleton variant="rounded" width={68} height={35} />
      </Box>
    </Box>
  );
};
